import { render, staticRenderFns } from "./Biologia.vue?vue&type=template&id=31325623"
import script from "./Biologia.vue?vue&type=script&lang=js"
export * from "./Biologia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports